// Individual MUI imports for better tree shaking
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import FormControl from "@mui/material/FormControl";
import Grid from "@mui/material/Grid";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import React from "react";
import { Smartphone } from "@mui/icons-material";

export default interface SIPAccountDialogProps {
    isShown: boolean;
    setShown: Function;
    SIPAccount: any;
    onCheckClientSubmitted: Function;
}
export default function SIPAccountDialog({isShown = false, setShown = ()=>{}, SIPAccount = undefined, onCheckClientSubmitted: onCheckClientClicked = ()=>{}}:SIPAccountDialog) {
  return (
    <Dialog
      open={isShown}
      onClose={() => setShown(false)}
      fullWidth={true}
      fullScreen={false}
    >
      <DialogContent>
        <Grid container>
          <Grid item lg={2} md={2} xs={2}>
            <Avatar
              sx={{
                width: 64,
                height: 64,
                backgroundColor:
                  SIPAccount?.status === "online" ? "green" : "grey",
              }}
            >
              <Smartphone />
            </Avatar>
          </Grid>
          <Grid item lg={10} md={10} xs={10}>
            <Typography variant="h6">{SIPAccount?.name}</Typography>
            <Typography variant="body1">{SIPAccount?.ip}</Typography>
          </Grid>
          <Grid item lg={12} sm={12} sx={{ marginTop: "10px" }}>
            <FormControl fullWidth>
              <TextField
                autoFocus
                id="sipAccount-username-textfield"
                name="sipAccount-username"
                label={`Tài khoản`}
                type="text"
                variant="outlined"
                value={SIPAccount?.id}
                disabled
              />
            </FormControl>
          </Grid>
          <Grid item lg={12} sm={12}>
            <FormControl fullWidth>
              <TextField
                autoFocus
                id="sipAccount-ip-textfield"
                name="sipAccount-ip"
                label={`IP`}
                type="text"
                variant="outlined"
                value={SIPAccount?.ip}
                disabled
              />
            </FormControl>
          </Grid>
          <Grid item lg={12} sm={12}>
            <FormControl fullWidth>
              <TextField
                autoFocus
                id="sipAccount-status-textfield"
                name="sipAccount-status"
                label={`Status`}
                type="text"
                variant="outlined"
                value={SIPAccount?.status}
                disabled
              />
            </FormControl>
          </Grid>
        </Grid>
        <Typography variant="body1" marginTop={"10px"}>
          Để kiểm tra điện thoại của bạn của hoạt động không vui lòng ấn nút
          "KIỂM TRA MÁY"
        </Typography>
      </DialogContent>
      {true ? (
        <DialogActions>
          <Button
            variant="text"
            onClick={() => {
              setShown(false);
            }}
          >
            Đóng
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={()=>{
                onCheckClientClicked();
            }}
          >
            Kiểm tra máy
          </Button>
        </DialogActions>
      ) : (
        <React.Fragment />
      )}
    </Dialog>
  );
}
